import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Users, Map, Calendar, Trophy } from "lucide-react";

const icons = { users: Users, map: Map, calendar: Calendar, trophy: Trophy };

export const StatTile = ({ stat }) => {
  const { tf } = useLang();
  const Icon = icons[stat.icon] || Users;
  return (
    <div className="group flex flex-col items-start gap-3 rounded-xl border border-gmoaa-border-subtle bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
      <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gmoaa-green-light text-gmoaa-green transition-colors group-hover:bg-gmoaa-green group-hover:text-white">
        <Icon size={22} />
      </span>
      <div>
        <p className="font-serif text-3xl font-bold text-gmoaa-green">{stat.value}</p>
        <p className="mt-1 text-sm text-gmoaa-text-muted">{tf(stat, "label")}</p>
      </div>
    </div>
  );
};
